import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../content/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('da'); // Default safe fallback
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Detect language on mount
    const savedLang = localStorage.getItem('kb_language');
    if (savedLang && (savedLang === 'da' || savedLang === 'en')) {
      setLang(savedLang);
    } else {
      const browserLang = navigator.language || navigator.userLanguage;
      const initialLang = browserLang.toLowerCase().startsWith('da') ? 'da' : 'en';
      setLang(initialLang);
    }
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;
    
    // Save to local storage
    localStorage.setItem('kb_language', lang);
    
    // Update HTML lang attribute
    document.documentElement.lang = lang;
    
    // Update SEO meta tags
    const t = translations[lang].seo;
    document.title = t.title;
    
    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.name = name;
        document.head.appendChild(el);
      }
      el.content = content;
    };
    
    const setOgMeta = (property, content) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.content = content;
    };

    setMeta('description', t.description);
    setOgMeta('og:title', t.title);
    setOgMeta('og:description', t.description);
    setOgMeta('twitter:title', t.title);
    setOgMeta('twitter:description', t.description);

  }, [lang, mounted]);

  const toggleLanguage = (newLang) => {
    setLang(newLang);
  };

  const t = translations[lang];

  if (!mounted) return null; // Prevent hydration mismatch

  return (
    <LanguageContext.Provider value={{ lang, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);